// Function to get current date in YYYY-MM-DD format
function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Function to calculate total weight sold in kilograms
function calculateTotalWeight() {
  let totalWeightKg = 0;
  const products = document.querySelectorAll('.product-item'); // Adjust selector based on your product markup

  products.forEach((product) => {
    const weightStr = product.querySelector('.product-weight').innerText; // Adjust selector based on your product markup
    const weightNum = parseFloat(weightStr.replace('kg', '').trim());
    if (!isNaN(weightNum)) {
      totalWeightKg += weightNum;
    }
  });

  return totalWeightKg.toFixed(2); // Limit to 2 decimal places
}

// Function to update popup content with current date and total weight
function updatePopupContent() {
  const currentDate = getCurrentDate();
  const totalWeight = calculateTotalWeight();

  document.getElementById('current-date').innerText = currentDate;
  document.getElementById('total-weight').innerText = totalWeight;
}

// Call updatePopupContent() when DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
  updatePopupContent();
});

// Close popup when close button is clicked
document.getElementById('popup-close').addEventListener('click', () => {
  document.getElementById('popup-overlay').style.display = 'none';
});
